export default __webpack_public_path__ + "app/images/theme-images/dark/404.svg";